import { applyCoupon, formatCoupon } from "../../../../../core/coupon";
import { Coupon, Currency } from "../../../../../graphql/operations";
import Money from "../../../../Atoms/Money";
import { Text } from "../../../../Atoms/Typography";
import styles from "./ReservationOffer.module.css";

interface Props {
  productId: string;
  currencyCode: Currency;
  lineItems: Array<{
    price: number;
    quantity: number;
  }>;
  couponCode?: string | null;
  privatePrice?: number;
  coupon: Coupon | null;
}

export default function ReservationOffer({
  currencyCode,
  lineItems,
  couponCode,
  privatePrice,
  coupon,
}: Props) {
  const originalPrice =
    lineItems.reduce((total, item) => total + item.price * item.quantity, 0) +
    (privatePrice ?? 0);
  const price = coupon ? applyCoupon(originalPrice, coupon) : originalPrice;

  return (
    <>
      {couponCode ? (
        <div className={styles.ReservationOrderPriceDiscount}>
          <div className={styles.ReservationOrderPriceLine}>
            <div className={styles.ReservationOrderPriceTotalLabel}>
              <Text size="small" muted>
                Subtotal
              </Text>
            </div>
            <div>
              {price !== originalPrice ? (
                <Text muted>
                  <Money amount={originalPrice} currency={currencyCode} />
                </Text>
              ) : null}
            </div>
          </div>

          <div className={styles.ReservationOrderPriceLine}>
            <div className={styles.ReservationOrderPriceTotalLabel}>
              <Text size="small" muted>
                Coupon {couponCode} applied
              </Text>
            </div>
            <div>
              <Text bold style={{ color: "#4caf50" }}>
                - {formatCoupon(coupon, currencyCode)}
              </Text>
            </div>
          </div>
        </div>
      ) : null}
      <div className={styles.ReservationOrderPriceTotal}>
        <div className={styles.ReservationOrderPriceTotalLabel}>
          <Text muted>Total Price ({currencyCode})</Text>
        </div>
        <Text size="large" bold>
          <Money amount={price} currency={currencyCode} />
        </Text>
      </div>
      <p style={{ textAlign: "right", fontSize: 11, color: "#878889" }}>
        All taxes and fees included
      </p>
    </>
  );
}
